import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import * as globalAdd from '../../../connectionString';
@Injectable()
export class SurveyServiceService {

  constructor(private http: HttpClient) { }

  getSurveyList(){
    return  this.http.get(globalAdd.Paneladdress + 'api/PA/Survey/getSurveyList');
  }
}
